export const unicampEmailFormatRegexp = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9-]+\.)*unicamp\.br$/g

export function unicampEmailFormatValidator(email: string): boolean {
  return email.trim().match(unicampEmailFormatRegexp) !== null
}
